export const GET_DRIVER_LOG = "GET_DRIVER_LOG";
export const GET_DRIVER_LOG_SUCCESS = "GET_DRIVER_LOG_SUCCESS";
export const GET_DRIVER_LOG_FAIL = "GET_DRIVER_LOG_FAIL";


export const GET_DRIVER_CHANGE_COORDINATE_LOGS = "GET_DRIVER_CHANGE_COORDINATE_LOGS";
export const GET_DRIVER_CHANGE_COORDINATE_LOGS_SUCCESS = "GET_DRIVER_CHANGE_COORDINATE_LOGS_SUCCESS";
export const GET_DRIVER_CHANGE_COORDINATE_LOGS_FAIL = "GET_DRIVER_CHANGE_COORDINATE_LOGS_FAIL";


export const UPDATE_CHANGE_LOCATION_STATUS = "UPDATE_CHANGE_LOCATION_STATUS";
export const UPDATE_CHANGE_LOCATION_STATUS_SUCCESS = "UPDATE_CHANGE_LOCATION_STATUS_SUCCESS";
export const UPDATE_CHANGE_LOCATION_STATUS_FAIL = "UPDATE_CHANGE_LOCATION_STATUS_FAIL";

export const GET_PLAN_CHANGE_STATUSES_EXCEL = "GET_PLAN_CHANGE_STATUSES_EXCEL";
export const GET_PLAN_CHANGE_STATUSES_EXCEL_SUCCESS = "GET_PLAN_CHANGE_STATUSES_EXCEL_SUCCESS";
export const GET_PLAN_CHANGE_STATUSES_EXCEL_FAIL = "GET_PLAN_CHANGE_STATUSES_EXCEL_FAIL";
export const CLEAR_PLAN_CHANGE_STATUSES_EXCEL = "CLEAR_PLAN_CHANGE_STATUSES_EXCEL";
